import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class FileIntegrationTabService {
	private selectedTab = new BehaviorSubject<{ tab: string }>({ tab: 'details' });

	setSelectedTab(tab: string) {
		this.selectedTab.next({ tab });
	}

	getSelectedTab() {
		return this.selectedTab.asObservable();
	}
}
